import { DefaultECGDataSchemaResponse, PermissionBit } from "../../../api";
import { AccessRules } from "../../../constants/roles";
import { DataModel } from "../../../models/data-model";

export class ECGs extends DataModel<DefaultECGDataSchemaResponse> {
  constructor(
    data: DefaultECGDataSchemaResponse[],
    permissions: PermissionBit[],
    userUUID: string,
  ) {
    super(data, permissions, userUUID);

    // access
    this.access = {
      editRules: { medical: AccessRules.none, monitoring: AccessRules.visible },
      deleteRules: {
        medical: AccessRules.none,
        monitoring: AccessRules.visible,
      },
      historyRequiresMonitoring: false,
    };
  }
}
